import dayjs from 'dayjs';
import type { MilestoneStatus } from '../types/milestones';

/** Days after the due date before Past Due turns from yellow (grace) to red. */
export const MILESTONE_PAST_DUE_GRACE_DAYS = 45;

export type MilestonePastDueBadgeStatus = 'past_due_grace' | 'past_due';

/**
 * Returns the Past Due badge status for a milestone, or null if it is not past due.
 * Within the grace period the badge is yellow; at/after grace days it is red.
 */
export function getMilestonePastDueBadgeStatus(
  status: MilestoneStatus,
  dueDate: string,
  now: dayjs.ConfigType = dayjs()
): MilestonePastDueBadgeStatus | null {
  if (status === 'completed') {
    return null;
  }

  const today = dayjs(now).startOf('day');
  const due = dayjs(dueDate).startOf('day');
  const daysPastDue = today.diff(due, 'day');

  if (daysPastDue <= 0) {
    return null;
  }

  if (daysPastDue < MILESTONE_PAST_DUE_GRACE_DAYS) {
    return 'past_due_grace';
  }

  return 'past_due';
}
